<template>
  <!-- main -->
  <div class="main">
    <h1>
      <img style="width: 100px; height: 100px" src="../assets/logo1.png" />停车管理系统
    </h1>
    <div class="login-form">
      <h2>
        <span @click="changeloginmode(2)" style="margin-left: 14px; cursor: pointer"
          :class="loginbyempcode === true ? 'active' : ''">系统登录</span>
      </h2>
      <div class="agileits-top">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
          <div class="styled-input">
            <input type="text" name="企业编码" required="" v-model="ruleForm.account" />
            <label>企业编码</label>
            <span></span>
          </div>
          <div v-show="loginbyempcode" class="styled-input">
            <input type="text" name="账号" required="" v-model="ruleForm.empcode" />
            <label>账号</label>
            <span></span>
          </div>
          <div class="styled-input">
            <input type="password" name="Password" required="" v-model="ruleForm.pwd" @keyup.enter="handleSubmit" />
            <label>密码</label>
            <span></span>
          </div>
          <div class="wthree-text">
            <ul>
              <li>
                <input type="checkbox" id="brand" value="" v-model="rememberpwd" />
                <label for="brand"><span></span> 记住我</label>
              </li>
              <li><a href="#"></a></li>
            </ul>
            <div class="clear"></div>
          </div>
        </el-form>
      </div>
      <div class="agileits-bottom">
        <el-button @click.native.prevent="handleSubmit" @keyup.enter.native="keyupEnter" :loading="logining">
          {{ loginStr }}
        </el-button>
      </div>
    </div>
    <div class="copyright">
      <p>
        ©<span style="margin-left: 5px">2019-{{ getdate }}</span> 重庆三核科技有限公司版权所有 |
        <a href="https://beian.miit.gov.cn" target="_blank">渝ICP备2022001610号</a><span style="margin-left: 10px">软件版本号：{{
          packconfig.version }}</span>
      </p>
      <div style="width: 300px; margin: 0 auto; padding: 20px 0">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=50010702503933" style="
            display: inline-block;
            text-decoration: none;
            height: 20px;
            line-height: 20px;
          "><img src="../assets/ga.png" style="float: left" />
          <p style="
              float: left;
              height: 20px;
              line-height: 20px;
              margin: 0px 0px 0px 5px;
              color: #fff;
            ">
            渝公网安备 50010702503933-1号
          </p>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { requestLogin, getUserByToken, getNavigationBar } from "../api/auth";
import router from "@/router";
import { filterAsyncRouter } from "@/router/index";
import index from "@/components/Pagination/index.vue";
import config from "../../package.json";
import { Base64 } from "@/utils/base64"
export default {
  components: { index },
  data() {
    return {
      instance: "",
      loginStr: "登录",
      logining: false,
      getdate: new Date().getFullYear(),
      loginbyempcode: true,
      loginmode: "账号登录",
      ruleForm: {
        account: "",
        empcode: "",
        pwd: "",
      },
      packconfig: config,
      path: "",
      rules: {
        account: [
          { required: true, message: "请输入企业编码", trigger: "blur" },
          //{ validator: validaePass }
        ],
        pwd: [
          { required: true, message: "请输入密码", trigger: "blur" },
          //{ validator: validaePass2 }
        ],
      },
      rememberpwd: false,
    };
  },
  created() {
    if (window.location.search.indexOf("?s=") === 0
      || window.location.search.indexOf("?r=") === 0
      || window.location.search.indexOf("?b=") === 0
      || window.location.search.indexOf("?f=") === 0
      || window.location.search.indexOf("?m=") === 0
      || window.location.search.indexOf("?z=") === 0
      || window.location.search.indexOf("?d=") === 0) {
      this.$router.replace("/needwx");
      }
    if (
      window.localStorage.rememberuser != null &&
      window.localStorage.rememberuser != undefined
    ) {
      var rememberuser = JSON.parse(window.localStorage.rememberuser);
      this.ruleForm.account = rememberuser.account;
      this.ruleForm.pwd = new Base64().decode(rememberuser.pwd);
      this.ruleForm.empcode = rememberuser.empcode;
      this.rememberpwd = rememberuser.remembermark;
    }
    this.keyupEnter();
  },
  methods: {
    keyupEnter() {
      document.onkeydown = (e) => {
        let body = document.getElementsByTagName("body")[0];
        if (
          e.keyCode === 13 &&
          e.target.baseURI.match(/login/) &&
          e.target === body
        ) {
          this.handleSubmit();
        }
      };
    },
    changeloginmode(value) {
      if (value == "1") {
        this.loginbyempcode = false;
      } else {
        this.loginbyempcode = true;
      }
    },
    // 获取 Token
    handleSubmit(ev) {
      var _this = this;
      var rulelogin = false;
      if (this.ruleForm.account === "" || this.ruleForm.pwd === "" || this.ruleForm.loginbyempcode === "") {
        _this.$message.error("企业编码，账号和密码不能为空！");
      } else {
        rulelogin = true;
      }
      if (rulelogin) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.logining = true;
            var loginParams = {
              account: this.ruleForm.account,
              empcode: this.loginbyempcode == true ? this.ruleForm.empcode : "",
              pwd: this.ruleForm.pwd,
            };
            _this.loginStr = "登录中...";
            requestLogin(loginParams)
              .then((data) => {
                var token = data.token;
                _this.$store.commit("saveToken", token);
                var curTime = new Date();
                var expiredate = new Date(
                  curTime.setSeconds(curTime.getSeconds() + data.expires_in)
                );
                _this.$store.commit("saveTokenExpire", expiredate);
                window.localStorage.refreshtime = expiredate;
                window.localStorage.expires_in = data.expires_in;
                window.localStorage.ExpirationDate = data.ExpirationDate;
                window.localStorage.ExpirationDay = data.ExpirationDay;
                window.localStorage.storecode = data.storecode;
                window.localStorage.ProductId = data.ProductId;
                if (this.rememberpwd) {
                  var rememberuser = JSON.parse(JSON.stringify(this.ruleForm));
                  rememberuser.pwd = new Base64().encode(rememberuser.pwd);
                  rememberuser.remembermark = true;
                  window.localStorage.rememberuser =
                    JSON.stringify(rememberuser);
                } else {
                  window.localStorage.rememberuser = null;
                }
                _this.getUserInfoByToken(token);
              })
              .catch((e) => {
                _this.logining = false;
                _this.loginStr = "重新登录";
              });
          } else {
            return false;
          }
        });
      }
    },
    // 获取用户数据
    getUserInfoByToken(token) {
      var _this = this;
      getUserByToken().then((data) => {
        window.localStorage.user = JSON.stringify(data);
        try {
          window.localStorage.selftype = data.syspara.filter(p => p.ParaKey == "ht01")[0].ParaValue;
        } catch {
          window.localStorage.selftype = false;
        }
        if (data.Id !== "0") {
          _this.GetNavigationBar();
        }
      });
    },
    // 获取路由树
    GetNavigationBar() {
      var _this = this;
      getNavigationBar().then((data) => {
        let userinfo = JSON.parse(
          window.localStorage.user ? window.localStorage.user : null
        );
        _this.$notify({
          type: "success",
          message: `登录成功 \n 欢迎您：${userinfo.EmpName} ！`,
          duration: 6000,
        });
        var ExpirationDay = Number(window.localStorage.ExpirationDay);
        if (ExpirationDay <= 3) {
          var msg =
            "<strong style='color:red;font-size:18px'>您的账号还有" +
            ExpirationDay +
            "天即将到期，到期后将无法使用，请及时联系客服续费或购买，联系电话：13452272601。</strong>";
          this.$alert(msg, "到期提醒", {
            confirmButtonText: "确定",
            dangerouslyUseHTMLString: true
          });
        }
        window.localStorage.router = JSON.stringify(data.children);
        let getRouter = data.children; //后台拿到路由
        getRouter = filterAsyncRouter(getRouter); //过滤路由
        router.$addRoutes(getRouter); //动态添加路由
        this.GetFirstRouter(getRouter);
        if (_this.$route.query.redirect != undefined) {
          var url = decodeURIComponent(_this.$route.query.redirect);
          if (url != undefined && url != null) {
            for (let i = 0; i < 10; i++) {
              url = decodeURIComponent(url);
            }
            url = url.substring(url.lastIndexOf("redirect=") + 9, url.length);
          }
          _this.$router.replace(url ? url : this.path);
        } else {
          _this.$router.replace(this.path);
        }
      });
    },
    GetFirstRouter(Routers) {
      Routers.some((element) => {
        if (element.path !== "-") {
          this.path = element.path;
          return true;
        } else if (element.children != null && element.children.length > 0) {
          this.GetFirstRouter(element.children);
        }
      });
    },
  },
  mounted() {
    window.localStorage.removeItem("expires_in");
    window.localStorage.removeItem("collapse");
    window.localStorage.removeItem("TokenExpire");
    window.localStorage.removeItem("router");
    window.localStorage.removeItem("Token");
    window.localStorage.removeItem("user");
    window.localStorage.removeItem("refreshtime");
  },
};
</script>
<style lang="css" scoped>
/*--reset--*/
html,
body,
div,
span,
applet,
object,
iframe,
h1,
h2,
h3,
h4,
h5,
h6,
p,
blockquote,
pre,
a,
abbr,
acronym,
address,
big,
cite,
code,
del,
dfn,
em,
img,
ins,
kbd,
q,
s,
samp,
small,
strike,
strong,
sub,
sup,
tt,
var,
b,
u,
i,
dl,
dt,
dd,
ol,
nav ul,
nav li,
fieldset,
form,
label,
legend,
table,
caption,
tbody,
tfoot,
thead,
tr,
th,
td,
article,
aside,
canvas,
details,
embed,
figure,
figcaption,
footer,
header,
hgroup,
menu,
nav,
output,
ruby,
section,
summary,
time,
mark,
audio,
video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
menu,
nav,
section {
  display: block;
}

ol,
ul {
  list-style: none;
  margin: 0px;
  padding: 0px;
}

blockquote,
q {
  quotes: none;
}

blockquote:before,
blockquote:after,
q:before,
q:after {
  content: "";
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

/*--start editing from here--*/
a {
  text-decoration: none;
}

.txt-rt {
  text-align: right;
}

/* text align right */
.txt-lt {
  text-align: left;
}

/* text align left */
.txt-center {
  text-align: center;
}

/* text align center */
.float-rt {
  float: right;
}

/* float right */
.float-lt {
  float: left;
}

/* float left */
.clear {
  clear: both;
}

/* clear float */
.pos-relative {
  position: relative;
}

/* Position Relative */
.pos-absolute {
  position: absolute;
}

/* Position Absolute */
.vertical-base {
  vertical-align: baseline;
}

/* vertical align baseline */
.vertical-top {
  vertical-align: top;
}

/* vertical align top */
nav.vertical ul li {
  display: block;
}

/* vertical menu */
nav.horizontal ul li {
  display: inline-block;
}

/* horizontal menu */
img {
  max-width: 100%;
}

/*--end reset--*/
.main {
  margin: 0 !important;
  padding: 0 !important;
  width: 100%;
  left: 0 !important;
  top: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  position: fixed;
  font-family: Verdana;
  background: url(../assets/banner.jpg) no-repeat center 0;
  background-attachment: fixed;
  background-size: cover;
  height: 100%;
}

.active {
  font-size: 24px;
}

h1 {
  font-size: 3em;
  text-align: center;
  color: #fff;
  font-weight: 100;
}

/*-- main --*/
h2 {
  font-size: 1.1em;
  text-align: center;
  padding: 1.2em;
  background: #02a299;
  color: #fff;
  font-weight: 200;
  letter-spacing: 10px;
}

.login-form {
  width: 35%;
  margin: 3.5em auto;
  background: rgba(12, 85, 105, 0.51);
  padding-bottom: 2em;
}

.agileits-top {
  padding: 2em 3em 3em;
}

.login-form input[type="text"],
.login-form input[type="password"] {
  font-size: 1em;
  color: #fff;
  padding: 0.8em 1em;
  border: 0;
  width: 93%;
  border-bottom: 1px solid #c7c7c7;
  background: none;
  -webkit-appearance: none;
}

/*-- input-effect --*/
.styled-input input:focus~label,
.styled-input input:valid~label {
  font-size: 1.1em;
  color: #02a299;
  top: -2em;
  -webkit-transition: all 0.125s ease;
  transition: all 0.125s ease;
}

.styled-input {
  width: 100%;
  margin: 2em 0 1em;
  position: relative;
}

.styled-input label {
  color: #fff;
  padding: 0.8em 1em;
  position: absolute;
  top: 0;
  left: 0;
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  transition: all 0.3s ease;
  pointer-events: none;
  font-weight: 400;
  font-size: 1em;
  display: block;
  line-height: 1em;
}

.styled-input input~span {
  display: block;
  width: 0;
  height: 2px;
  background: #fff;
  position: absolute;
  bottom: 0;
  left: 0;
  -webkit-transition: all 0.125s ease;
  transition: all 0.125s ease;
}

.styled-input input:focus {
  outline: 0;
}

.styled-input input:focus~span {
  width: 100%;
  -webkit-transition: all 0.075s ease;
  transition: all 0.075s ease;
  font: "OpenSans-Regular";
}

/*-- //input-effect --*/
.login-form p {
  font-size: 1em;
  color: #fff;
  margin: 1em 0 0.5em;
}

/*-- checkbox --*/
.wthree-text input[type="checkbox"] {
  display: none;
}

.wthree-text input[type="checkbox"]+label {
  position: relative;
  padding-left: 1.8em;
  border: none;
  outline: none;
  font-size: 1em;
  color: #fff;
  cursor: pointer;
  display: block;
}

.wthree-text input[type="checkbox"]+label span:first-child {
  width: 14px;
  height: 14px;
  border: 2px solid #fff;
  position: absolute;
  left: 0;
  top: 2px;
}

.wthree-text input[type="checkbox"]:checked+label span:first-child:before {
  content: "";
  background: url(../assets/tick.png) no-repeat;
  position: absolute;
  left: 2px;
  top: 2px;
  font-size: 10px;
  width: 10px;
  height: 10px;
}

/*-- //checkbox --*/
.wthree-text {
  margin-top: 3em;
}

.wthree-text ul li {
  display: inline-block;
  float: left;
}

.wthree-text ul li:nth-child(2) {
  float: right;
}

.wthree-text ul li a {
  font-size: 1em;
  color: #fff;
}

.wthree-text ul li a:hover {
  color: #02a299;
}

.agileits-bottom {
  position: relative;
}

.agileits-bottom:before {
  content: "";
  position: absolute;
  top: -17px;
  left: -17px;
  width: 0;
  height: 0;
  border-top: 17px solid transparent;
  border-right: 18px solid #fff;
  transition: 0.5s all ease;
}

.agileits-bottom:after {
  content: "";
  position: absolute;
  top: -17px;
  right: -17px;
  width: 0;
  height: 0;
  border-left: 17px solid #fff;
  border-top: 17px solid transparent;
  transition: 0.5s all ease;
}

.agileits-bottom button {
  font-size: 1.5em;
  color: #02a299;
  background: #fff;
  outline: none;
  cursor: pointer;
  padding: 1em 0;
  -webkit-appearance: none;
  border: none;
  width: 106%;
  margin-left: -0.7em;
  text-transform: uppercase;
}

.agileits-bottom button:hover {
  color: #fff;
  background: #02a299;
  transition: 0.5s all ease;
}

.agileits-bottom:hover:before {
  border-right-color: #02a299;
}

.agileits-bottom:hover:after {
  border-left-color: #02a299;
}

/*-- //main --*/
/*-- copyright --*/
.copyright {
  margin: 2em 0;
  text-align: center;
}

.copyright p {
  font-size: 1em;
  color: #fff;
  line-height: 1.8em;
}

.copyright p a {
  color: #fff;
  -webkit-transition: 0.5s all;
  -moz-transition: 0.5s all;
  -o-transition: 0.5s all;
  -ms-transition: 0.5s all;
  transition: 0.5s all;
}

.copyright p a:hover {
  color: #000;
}

/*-- //copyright --*/
/*-- responsive-design --*/
@media (max-width: 1440px) {
  .agileits-bottom input[type="submit"] {
    width: 106.8%;
  }
}

@media (max-width: 1366px) {
  .login-form {
    width: 37%;
    margin: 3em auto;
  }
}

@media (max-width: 1280px) {
  .login-form {
    width: 40%;
  }
}

@media (max-width: 1080px) {
  .main {
    padding: 2em 0 0;
  }

  .login-form {
    width: 48%;
  }

  h1 {
    font-size: 2.8em;
  }
}

@media (max-width: 1024px) {
  h1 {
    font-size: 2.6em;
  }

  .login-form {
    width: 50%;
    margin: 2em auto;
  }
}

@media (max-width: 991px) {
  h1 {
    font-size: 2.5em;
  }

  .login-form {
    width: 52%;
  }
}

@media (max-width: 900px) {
  .agileits-top {
    padding: 1em 3em 3em;
  }

  .login-form {
    width: 56%;
    padding-bottom: 3.5em;
  }
}

@media (max-width: 800px) {
  .login-form {
    width: 63%;
  }

  .agileits-top {
    padding: 1em 2.5em 2.5em;
  }

  .agileits-bottom input[type="submit"] {
    font-size: 1.3em;
    margin-left: -0.8em;
  }
}

@media (max-width: 768px) {
  h1 {
    font-size: 2.3em;
  }

  .agileits-bottom input[type="submit"] {
    width: 107%;
  }
}

@media (max-width: 736px) {
  .agileits-bottom input[type="submit"] {
    width: 107.5%;
  }
}

@media (max-width: 667px) {
  .agileits-bottom input[type="submit"] {
    width: 108%;
    font-size: 1.1em;
    margin-left: -0.9em;
  }
}

@media (max-width: 640px) {
  .login-form {
    width: 67%;
  }

  .agileits-bottom input[type="submit"] {
    width: 108%;
  }
}

@media (max-width: 600px) {
  .agileits-bottom input[type="submit"] {
    width: 108.7%;
  }
}

@media (max-width: 480px) {
  h1 {
    font-size: 1.8em;
  }

  h2 {
    font-size: 1em;
    padding: 1em;
    letter-spacing: 7px;
  }

  .agileits-top {
    padding: 1em 1.5em 1.5em;
  }

  .login-form input[type="text"],
  .login-form input[type="password"] {
    font-size: 0.9em;
    padding: 0.6em 1em;
    width: 93%;
  }

  .styled-input label {
    padding: 0.6em 1em;
    font-size: 0.9em;
  }

  .styled-input input:focus~label,
  .styled-input input:valid~label {
    font-size: 1em;
    top: -1.5em;
  }

  .wthree-text {
    margin-top: 2em;
  }

  .wthree-text input[type="checkbox"]+label {
    font-size: 0.9em;
    padding-left: 1.5em;
  }

  .wthree-text input[type="checkbox"]+label span:first-child {
    width: 12px;
    height: 12px;
  }

  .wthree-text ul li a {
    font-size: 0.9em;
  }

  .agileits-bottom input[type="submit"] {
    font-size: 1em;
    margin-left: -0.6em;
    width: 105.3%;
    padding: 0.8em 0;
  }

  .login-form {
    padding-bottom: 3em;
  }

  .login-form {
    width: 80%;
  }

  .copyright p {
    font-size: 0.9em;
  }

  .agileits-bottom:before {
    top: -11px;
    left: -11px;
    border-top: 11px solid transparent;
    border-right: 11px solid #fff;
  }

  .agileits-bottom:after {
    top: -11px;
    right: -11px;
    border-left: 11px solid #fff;
    border-top: 11px solid transparent;
  }

  .wthree-text input[type="checkbox"]:checked+label span:first-child:before {
    left: 1px;
    top: 1px;
  }
}

@media (max-width: 414px) {
  .main {
    padding: 1.5em 0 0;
  }

  .styled-input {
    margin: 1.5em 0 1em;
  }

  .copyright p {
    padding: 0 1em;
  }

  .agileits-bottom:before {
    top: -10px;
    left: -10px;
    border-top: 10px solid transparent;
    border-right: 10px solid #fff;
  }

  .agileits-bottom:after {
    top: -10px;
    right: -10px;
    border-left: 10px solid #fff;
    border-top: 10px solid transparent;
  }

  .agileits-bottom input[type="submit"] {
    width: 106%;
  }
}

@media (max-width: 384px) {
  .agileits-bottom input[type="submit"] {
    width: 106.8%;
    font-size: 0.9em;
    margin-left: -0.7em;
  }
}

@media (max-width: 375px) {
  .agileits-bottom input[type="submit"] {
    width: 106.5%;
    margin-left: -0.6em;
  }

  h1 {
    font-size: 1.6em;
  }

  h2 {
    letter-spacing: 5px;
  }

  .login-form {
    margin: 1.5em auto;
  }

  .wthree-text ul li {
    float: none;
    display: block;
  }

  .wthree-text ul li:nth-child(2) {
    float: none;
    margin-top: 1em;
  }

  .wthree-text {
    margin-top: 1.5em;
  }
}

@media (max-width: 320px) {
  h2 {
    letter-spacing: 3px;
    padding: 0.8em;
  }

  .login-form {
    width: 85%;
  }

  .agileits-top {
    padding: 0.5em 1em 1.5em;
  }

  .login-form input[type="text"],
  .login-form input[type="password"] {
    font-size: 0.85em;
    padding: 0.6em;
    width: 88%;
  }

  .styled-input label {
    padding: 0.6em;
    font-size: 0.85em;
  }

  .styled-input input:focus~label,
  .styled-input input:valid~label {
    font-size: 0.9em;
    top: -1em;
  }

  .login-form {
    padding-bottom: 2em;
  }

  .agileits-bottom input[type="submit"] {
    width: 107%;
    margin-left: -0.6em;
  }
}

/*-- //responsive-design --*/
</style>
